import React from "react"
import { TableRow, Stack } from "@mui/material"
import { PETextField, PEInProgressReprodChip, PEDoneReprodChip } from "../StyledPackagingExecutionPreviewComponents"
import { StyledBodyCell } from "../../../components/styled/StyledTableComponents"
import FormikErrorMessage from "../../../components/FormikErrorMessage"
import PECellValue from "../PECellValue"
import { convertKilosIntoGrams } from "../../../utils/ressources"
import { roundNumber } from "../../../utils"
import { COLORS } from "../../../utils"

const PackagingExecutionSection = ({
	section,
	index,
	lastSectionIdx,
	editable,
	setFieldTouched,
	onChangeSectionRealWeight,
	setFocusedFieldIndex
}) => {
	const _renderKiloToGrams = (value, shouldRound = true) => {
		const convertedValue = convertKilosIntoGrams(value)
		if (shouldRound) {
			return roundNumber(convertedValue, 0)
		}
		return convertedValue
	}

	const hasOngoingReproduction = (section) => {
		return (section.reproductions || []).some(
			(reprod) => reprod.status === "IN_PROGRESS"
		)
	}

	return (
		<TableRow>
			<StyledBodyCell leftEdge={true} lastBodyRow={index === lastSectionIdx}>
				{section.sectionName || "-"}
				{section.reproductions.length > 0 && (
					hasOngoingReproduction(section)
						? <PEInProgressReprodChip label="Reprod en cours" />
						: <PEDoneReprodChip label="Reprod incluse" />
				)}
			</StyledBodyCell>
			<StyledBodyCell lastBodyRow={index === lastSectionIdx}>
				<PECellValue
					value1={roundNumber((section.productionWeight || 0), 2)}
					value2={roundNumber((section.totalTheoreticalWeight || 0), 2)}
					unit="kg"
				/>
			</StyledBodyCell>
			<StyledBodyCell lastBodyRow={index === lastSectionIdx}>
				<PECellValue
					value1={_renderKiloToGrams((section.recipeSectionWeight || 0), 2)}
					unit="g"
				/>
			</StyledBodyCell>
			<StyledBodyCell lastBodyRow={index === lastSectionIdx}>
				{editable ? (
					<Stack direction="row" alignItems="center" gap={1}>
						<PETextField
							name={`sections[${index}].realWeight`}
							value={section.realWeight === "" ? "" : _renderKiloToGrams(section.realWeight, false)}
							variant="outlined"
							onChange={(e) => {
								setFieldTouched(`sections[${index}].realWeight`, true, false)
								onChangeSectionRealWeight(e.target.value)
							}}
							type="number"
							onWheel={(e) => e.target.blur()}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault()
									e.target.blur()
								}
							}}
							inputProps={{
								inputMode: "numeric",
								pattern: "[0-9]*"
							}}
							onFocus={() => setFocusedFieldIndex(index)}
							onBlur={() => setFocusedFieldIndex(null)}
						/>
						<span style={{ color: COLORS.DRAFT_GREY }}> g</span>
					</Stack>
				) :
					<PECellValue
						value1={_renderKiloToGrams(section.realWeight) || 0}
						unit="g"
					/>
				}
				<FormikErrorMessage name={`sections[${index}].realWeight`} />
			</StyledBodyCell>
			<StyledBodyCell rightEdge={true} lastBodyRow={index === lastSectionIdx}>
				<PECellValue
					value1={roundNumber((section.forecastWaste || 0), 1)}
					unit="kg"
				/>
			</StyledBodyCell>
		</TableRow>
	)
}

export default PackagingExecutionSection